export const PUBLIC_REPORT_HOST = 'https://bmwstation.fut-app.com';

export function publicResaleReportUrl(token) {
  const base =
    process.env.REACT_APP_PUBLIC_REPORT_BASE_URL?.replace(/\/$/, '') ||
    PUBLIC_REPORT_HOST;
  return `${base}/r/${token}`;
}

/** Used in WhatsApp/social shares so crawlers get dynamic OG tags (Supabase Edge Function). */
export function publicResalePreviewUrl(token) {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL?.replace(/\/$/, '');
  if (!supabaseUrl || !token) return publicResaleReportUrl(token);
  return `${supabaseUrl}/functions/v1/resale-report-og?token=${encodeURIComponent(token)}`;
}

export function whatsAppShareUrl(text) {
  return `https://wa.me/?text=${encodeURIComponent(text)}`;
}

export function resaleShareMessage(report, url) {
  const vehicle = [report.brand, report.model, report.year, report.plate_number]
    .filter(Boolean)
    .join(' ');
  return [
    'Certified pre-purchase inspection report',
    vehicle || 'Vehicle inspection',
    report.report_number ? `Report ${report.report_number}` : null,
    url,
  ]
    .filter(Boolean)
    .join('\n');
}
